import { useMutation } from "@/api/utils/useQuery"
import { MutationResult } from "@/api/utils/types"
import { EdgeConfigMutations } from "@/api/edgeConfig/mutations"
import {
  IMaintenanceConfig,
  IMaintenanceConfigSerialized,
} from "./MaintenanceMutator.types"

export interface IMaintenanceMutator {
  updateConfig(): MutationResult<IMaintenanceConfig>
}

class MaintenanceMutatorClass implements IMaintenanceMutator {
  updateConfig() {
    return useMutation({
      ...EdgeConfigMutations.maintenance.update(),
      serializerFn: (
        data: IMaintenanceConfig,
      ): IMaintenanceConfigSerialized => ({
        items: Object.entries(data).map(([key, value]) => ({
          operation: "upsert",
          key,
          value,
        })),
      }),
    })
  }
}

export const MaintenanceMutator = new MaintenanceMutatorClass()
